import React, { FC } from 'react';
import Modal from './common/Modal/Modal';
import { Ul } from './common/Modal/styles';

interface ModalTransactionDelayProps {
  isShow: boolean;
}

const ModalTransactionDelay: FC<ModalTransactionDelayProps> = ({ isShow }) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      title="Transaction on going"
      isXButton={false}
      footerComponent={<></>}
    >
      <Ul>
        <li>Transaction is currently being processed.</li>
        <li>
          This process is automatic and can take about 1 to 2 minutes. It may
          take longer depending on the transaction condition.
        </li>

        <li>
          If you refresh or try again during processing, the transaction may not
          be processed normally, so please wait for a while until the completion
          notice.
        </li>
      </Ul>
    </Modal>
  );
};

export default ModalTransactionDelay;
